export default function PHP_addslashes() {
  return (
    <div>
      <h1>PHP_addslashes</h1>
    </div>
  );
}
